import { jsx as r } from "react/jsx-runtime";
import { U as o } from "../../../vendor--aJiswR_.js";
import '../../../assets/index44.css';const a = "_separator_1opib_1", t = {
  separator: a
};
function p() {
  return /* @__PURE__ */ r(o, { className: t.separator, orientation: "horizontal" });
}
export {
  p as Separator
};
//# sourceMappingURL=index.js.map
